module.exports = __webpack_public_path__ + "img/horizontal_4_1_8004.0363d06e.png";